import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'

import { ProxyVotingComponent } from './proxy-voting.component'

@NgModule({
  declarations: [ProxyVotingComponent],
  imports: [CommonModule],
  exports: [ProxyVotingComponent],
})
export class ProxyVotingModule {}
